import { regionConfig } from '../regionConfig'
import { useRegion } from '../RegionProvider'

export function useCanTrack() {
  const regionCode = useRegion()

  if (regionConfig[regionCode]?.gdprCompliant === false) {
    return true
  } else {
    // If we don't know whether a region is gdprCompliant then we assume it is to be safe.
    return false
  }
}
